




import { Component, Vue, Prop } from "vue-property-decorator";
import * as AppNotification from "@/models/notifications/notification";

@Component
export default class NotificationComponent extends Vue {
  @Prop() notification!: AppNotification.Notification;
  @Prop({ default: false }) dismissible!: boolean;

  get type(): string {
    if (this.notification.type == AppNotification.NotificationType.Success)
      return "success";
    if (this.notification.type == AppNotification.NotificationType.Error)
      return "error";
    return "info";
  }
}
